// Display formatter: whole numbers show no decimal, otherwise 2 decimal places.
// Returns a string suitable for rendering in the UI.
export const formatMoney = (n) => {
  if (n === undefined || n === null || isNaN(n)) return '0';
  return n % 1 === 0 ? String(Math.floor(n)) : n.toFixed(2);
};

// Math utility: truncate (floor) to 2 decimal places. Returns a number.
// Use this for calculations, not display.
export const truncateToTwoDecimals = (number) => Math.floor(number * 100) / 100;
